(function () {
  var endpoint = 'https://solar-oracle-deepseek-proxy.dontmarryme.workers.dev/chat';
  var widget = document.querySelector('[data-llm-footer-chat]');
  var contextScript = document.querySelector('[data-llm-footer-chat-context]');

  if (!widget || !contextScript) {
    return;
  }

  var form = widget.querySelector('[data-llm-footer-chat-form]');
  var input = widget.querySelector('[data-llm-footer-chat-input]');
  var output = widget.querySelector('[data-llm-footer-chat-output]');
  var submit = widget.querySelector('[data-llm-footer-chat-submit]');
  var toggle = widget.querySelector('[data-llm-footer-chat-toggle]');
  var toggleLabel = widget.querySelector('[data-llm-footer-chat-toggle-label]');
  var baseContext = {};
  var shopKnowledgePromise = null;
  var shopPersonaPromise = null;
  var sessionKey = 'weiweiweishop.llmFooterChat.session.v1';
  var minimizedKey = 'weiweiweishop.llmFooterChat.minimized.v1';
  var sessionTtl = 30 * 60 * 1000;
  var maxSessionTurns = 6;

  try {
    baseContext = JSON.parse(contextScript.textContent || '{}');
  } catch (error) {
    baseContext = {};
  }

  function ensureToggle() {
    var inner = widget.querySelector('.llm-footer-chat__inner') || widget;

    if (toggle) {
      if (toggle.parentElement !== inner) {
        inner.appendChild(toggle);
      }
      return;
    }

    var icon = document.createElement('span');
    icon.className = 'llm-footer-chat__toggle-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '🐁';

    toggleLabel = document.createElement('span');
    toggleLabel.className = 'llm-footer-chat__toggle-label';
    toggleLabel.setAttribute('data-llm-footer-chat-toggle-label', '');
    toggleLabel.textContent = '';

    toggle = document.createElement('button');
    toggle.className = 'llm-footer-chat__toggle';
    toggle.setAttribute('data-llm-footer-chat-toggle', '');
    toggle.type = 'button';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Expand wise mouse operator one');
    toggle.appendChild(toggleLabel);
    toggle.appendChild(icon);

    inner.appendChild(toggle);
  }

  function renameLaserProductTitle() {
    if (window.location.pathname !== '/products/405nm-laser') {
      return;
    }

    var title = 'Mind The Mouse With Laser 405';
    document.querySelectorAll('.product__title h1, .product__title h2').forEach(function (element) {
      element.textContent = title;
    });
  }

  function ensureSingleChatFrame() {
    if (!form || !output) {
      return;
    }

    if (output.parentElement !== form) {
      form.insertBefore(output, form.firstChild);
    }
  }

  ensureToggle();
  ensureSingleChatFrame();
  renameLaserProductTitle();

  function truncateText(text, maxLength) {
    if (!text) {
      return '';
    }

    var compactText = text.replace(/\s+/g, ' ').trim();

    if (compactText.length <= maxLength) {
      return compactText;
    }

    return compactText.slice(0, maxLength) + '...';
  }

  function getVisiblePageText() {
    var clone = document.body.cloneNode(true);
    var chat = clone.querySelector('[data-llm-footer-chat]');
    var chatContext = clone.querySelector('[data-llm-footer-chat-context]');

    if (chat) {
      chat.remove();
    }

    if (chatContext) {
      chatContext.remove();
    }

    return truncateText(clone.innerText || '', 1600);
  }

  function normalizeWords(text) {
    return (text || '')
      .toLowerCase()
      .replace(/[^a-z0-9\u4e00-\u9fff]+/g, ' ')
      .split(' ')
      .filter(function (word) {
        return word.length > 1;
      });
  }

  function matchesQuestion(item, words) {
    var haystack = JSON.stringify(item || {}).toLowerCase();

    return words.some(function (word) {
      return haystack.indexOf(word) !== -1;
    });
  }

  function compactShopKnowledge(shopKnowledge, question) {
    if (!shopKnowledge) {
      return null;
    }

    var words = normalizeWords(question);
    var products = (shopKnowledge.products || []).filter(function (product) {
      return matchesQuestion(product, words);
    });
    var pressAndArticles = (shopKnowledge.pressAndArticles || []).filter(function (article) {
      return matchesQuestion(article, words);
    });

    if (!products.length) {
      products = (shopKnowledge.products || []).slice(0, 4);
    }

    if (!pressAndArticles.length) {
      pressAndArticles = (shopKnowledge.pressAndArticles || []).slice(0, 3);
    }

    return {
      policies: shopKnowledge.policies,
      shop: shopKnowledge.shop,
      artist: shopKnowledge.artist,
      brandTerms: shopKnowledge.brandTerms,
      relevantProducts: products.slice(0, 6),
      relevantProjects: (shopKnowledge.projects || []).filter(function (project) {
        return matchesQuestion(project, words);
      }).slice(0, 4),
      relevantPressAndArticles: pressAndArticles.slice(0, 4),
      faqs: (shopKnowledge.faqs || []).filter(function (faq) {
        return matchesQuestion(faq, words);
      }).slice(0, 4)
    };
  }

  function getShippingRatesForQuestion(question, shopKnowledge) {
    if (!shopKnowledge || !shopKnowledge.shippingRates || !/ship|shipping|deliver|delivery|usa|united states|taiwan|運送|運費|寄送/i.test(question)) {
      return null;
    }

    return shopKnowledge.shippingRates;
  }

  function getUseCaseGuidanceForQuestion(question, shopKnowledge) {
    if (!shopKnowledge || !shopKnowledge.useCaseGuidance) {
      return null;
    }

    if (/3d|printing|printer|additive/i.test(question)) {
      return shopKnowledge.useCaseGuidance.galvoScanner3dPrinting || null;
    }

    return null;
  }

  function getSessionContext() {
    var emptySession = {
      updatedAt: Date.now(),
      turns: []
    };

    try {
      var storedSession = JSON.parse(sessionStorage.getItem(sessionKey) || 'null');

      if (!storedSession || !storedSession.updatedAt || Date.now() - storedSession.updatedAt > sessionTtl) {
        sessionStorage.removeItem(sessionKey);
        return emptySession;
      }

      storedSession.turns = (storedSession.turns || []).slice(-maxSessionTurns);
      return storedSession;
    } catch (error) {
      sessionStorage.removeItem(sessionKey);
      return emptySession;
    }
  }

  function saveSessionContext(sessionContext) {
    try {
      sessionContext.updatedAt = Date.now();
      sessionContext.turns = (sessionContext.turns || []).slice(-maxSessionTurns);
      sessionStorage.setItem(sessionKey, JSON.stringify(sessionContext));
    } catch (error) {
      sessionStorage.removeItem(sessionKey);
    }
  }

  function rememberTurn(sessionContext, question, answer) {
    sessionContext.turns = sessionContext.turns || [];
    sessionContext.turns.push({
      question: truncateText(question, 400),
      answer: truncateText(answer, 600)
    });
    saveSessionContext(sessionContext);
  }

  function setLoading(isLoading) {
    input.disabled = isLoading;

    if (submit) {
      submit.disabled = isLoading;
      submit.textContent = isLoading ? '...' : 'Ask';
    }

    input.setAttribute('aria-busy', String(isLoading));
    input.placeholder = isLoading ? 'Thinking…' : 'Type and press Enter…';
  }

  function appendChatLine(kind, label, text) {
    if (!text) {
      return;
    }

    var row = document.createElement('div');
    row.className = 'llm-footer-chat__line llm-footer-chat__line--' + kind;

    var labelElement = document.createElement('div');
    labelElement.className = 'llm-footer-chat__line-label';
    labelElement.textContent = label;

    var textElement = document.createElement('div');
    textElement.className = 'llm-footer-chat__line-text';
    textElement.textContent = text;

    row.appendChild(labelElement);
    row.appendChild(textElement);
    output.appendChild(row);
  }

  function setOutput(message, isError, question) {
    output.textContent = '';
    output.hidden = !message && !question;
    output.classList.toggle('is-error', Boolean(isError));

    if (question) {
      appendChatLine('question', 'You asked', question);
    }

    if (message) {
      appendChatLine(isError ? 'error' : 'answer', isError ? 'Assistant error' : 'Wise mouse', message);
    }
  }

  function setMinimized(isMinimized) {
    widget.classList.toggle('is-minimized', Boolean(isMinimized));

    if (toggle) {
      toggle.setAttribute('aria-expanded', String(!isMinimized));
      toggle.setAttribute('aria-label', isMinimized ? 'Expand wise mouse operator one' : 'Minimize wise mouse operator one');
    }

    if (toggleLabel) {
      toggleLabel.textContent = '';
    }

    try {
      sessionStorage.setItem(minimizedKey, isMinimized ? '1' : '0');
    } catch (error) {
      // Keep the widget usable when storage is unavailable.
    }
  }

  function getInitialMinimizedState() {
    try {
      sessionStorage.removeItem(minimizedKey);
    } catch (error) {
      // Keep the widget usable when storage is unavailable.
    }

    return true;
  }

  function pickReply(data) {
    if (!data) {
      return '';
    }

    if (typeof data === 'string') {
      return data;
    }

    return data.answer || data.reply || data.content || data.message || '';
  }

  function getShopKnowledge() {
    if (!baseContext.knowledgeUrl) {
      return Promise.resolve(null);
    }

    if (!shopKnowledgePromise) {
      shopKnowledgePromise = fetch(baseContext.knowledgeUrl, {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Knowledge file unavailable');
          }

          return response.json();
        })
        .catch(function () {
          return null;
        });
    }

    return shopKnowledgePromise;
  }

  function getShopPersona() {
    if (!baseContext.personaUrl) {
      return Promise.resolve(null);
    }

    if (!shopPersonaPromise) {
      shopPersonaPromise = fetch(baseContext.personaUrl, {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Persona file unavailable');
          }

          return response.json();
        })
        .catch(function () {
          return null;
        });
    }

    return shopPersonaPromise;
  }

  function cleanReply(text) {
    return (text || '')
      .replace(/#{1,6}\s*/g, '')
      .replace(/\*\*/g, '')
      .replace(/`/g, '')
      .replace(/^[-*]\s+/gm, '')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var message = input.value.trim();

    if (!message) {
      input.focus();
      return;
    }

    input.value = '';

    var sessionContext = getSessionContext();

    var context = Object.assign({}, baseContext, {
      currentUrl: window.location.href,
      path: window.location.pathname,
      visiblePageText: getVisiblePageText(),
      language: document.documentElement.lang || navigator.language || '',
      recentConversation: sessionContext.turns
    });

    setLoading(true);
    setOutput('Reading this page and asking the shop assistant...', false, message);

    Promise.all([getShopKnowledge(), getShopPersona()])
      .then(function (results) {
        var shopKnowledge = results[0];
        var shopPersona = results[1];

        if (shopKnowledge) {
          context.shopKnowledge = compactShopKnowledge(shopKnowledge, message);
          context.verifiedShippingRates = getShippingRatesForQuestion(message, shopKnowledge);
          context.useCaseGuidance = getUseCaseGuidanceForQuestion(message, shopKnowledge);
        }

        if (shopPersona) {
          context.persona = shopPersona;
        }

        var systemContent = 'You are wise mouse operator one for weiweiweishop. Detect the buyer language from the latest user message and reply in that same language. If the buyer mixes languages, use the main language they used most, while keeping product names in their original form. Use plain text only. Never use Markdown, headings, bullet lists, bold syntax, code formatting, hash symbols, or decorative quotes. Keep answers short, warm, wise, and lightly humorous, usually 2 to 5 sentences. Answer price, shipping, and stock questions directly first. If useCaseGuidance is present, follow it over the visible page text because it is a curator-approved answer for that use case. Verified shipping rates in the provided context are official public Shopify storefront rates and should be answered directly, while reminding customers to confirm final checkout rates. Do not invent stock, private order, account, warranty, or delivery details. Public storefront context, shop knowledge, and persona: ' + truncateText(JSON.stringify(context), 10000);
        var conversationMessages = (sessionContext.turns || []).slice(-3).reduce(function (messages, turn) {
          messages.push({
            role: 'user',
            content: turn.question
          });
          messages.push({
            role: 'assistant',
            content: turn.answer
          });
          return messages;
        }, []);
        var messages = [
          {
            role: 'system',
            content: systemContent
          }
        ].concat(conversationMessages, [
          {
            role: 'user',
            content: message
          }
        ]);

        return fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            mode: 'chat',
            messages: messages
          })
        });
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Assistant request failed: HTTP ' + response.status);
        }

        return response.json();
      })
      .then(function (data) {
        var reply = cleanReply(pickReply(data));
        rememberTurn(sessionContext, message, reply);
        setOutput(reply || 'I could not find an answer for that yet. Please try asking another way.', false, message);
      })
      .catch(function (error) {
        var errorMessage = error && error.message ? ' (' + error.message + ')' : '';
        setOutput('Sorry, the assistant is unavailable right now. Please try again in a moment.' + errorMessage, true, message);
      })
      .finally(function () {
        setLoading(false);
      });
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      form.requestSubmit();
    }
  });

  if (toggle) {
    setMinimized(getInitialMinimizedState());

    toggle.addEventListener('click', function () {
      var nextMinimizedState = !widget.classList.contains('is-minimized');
      setMinimized(nextMinimizedState);

      if (!nextMinimizedState) {
        input.focus();
      }
    });
  }

  document.addEventListener('pointerdown', function (event) {
    if (widget.classList.contains('is-minimized')) {
      return;
    }

    if (widget.contains(event.target)) {
      return;
    }

    setMinimized(true);
  });
})();
